import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce76439a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "notification__wrapper" }
const _hoisted_4 = { class: "notification__icon" }
const _hoisted_5 = { class: "notification__content" }
const _hoisted_6 = { class: "notification__content__title" }
const _hoisted_7 = { class: "notification__content__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["notification", _ctx.details.className]),
            style: _normalizeStyle(`--width: ${_ctx.computedWidth}%`)
          }, [
            _createElementVNode("button", {
              class: "notification__close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCloseClick && _ctx.handleCloseClick(...args)))
            }, _hoisted_2),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass(["icon", _ctx.details.iconClass])
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(_ctx.notification.title)), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(_ctx.notification.content, _ctx.notification.params || {})), 1)
              ])
            ])
          ], 6))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}